import * as S from './TimelineAvatar.styles'

interface TimelineAvatarProps {
  name?: string | null
  variant: S.AvatarVariant
}

const getInitials = (name: string | null | undefined, fallback: string) => {
  const initials = String(name ?? '')
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .map(word => word[0])
    .slice(0, 2)
    .join('')
    .toUpperCase()

  return initials || fallback
}

export const TimelineAvatar = ({ name, variant }: TimelineAvatarProps) => (
  <S.Root $variant={variant}>{getInitials(name, variant === 'guest' ? 'G' : 'A')}</S.Root>
)
